export default __webpack_public_path__ + "static/media/orderready.82a6b7df.svg";